import { Component, OnInit, Input, Output, EventEmitter, OnChanges, OnDestroy } from '@angular/core';

import { DialogService } from 'primeng/dynamicdialog';

import { CalculationService, DataService, HelperService, HTTPService } from 'app/services';
import { ConfirmDismissDialogComponent } from 'app/modules/shared/components';
import { currency } from 'app/constants/currency.constants';
import { config } from 'app/constants';

import { find } from 'lodash';
import { Subscription } from 'rxjs';
import { QtyOnEstimateListModalComponent } from 'app/modules/app-components/qty-on-estimate-list-modal/qty-on-estimate-list-modal.component';

@Component({
  selector: 'app-tire-size',
  templateUrl: './tire-size.component.html',
  styleUrls: ['./tire-size.component.scss'],
  providers: [DialogService],
})
export class TireSizeComponent implements OnInit, OnChanges, OnDestroy {
  @Input() index: number = 0;
  @Input() size: any = {};
  @Input() pricings: any[] = [];
  @Input() pricingRules: any[] = [];
  @Input() errors: any = {};
  @Input() qboItemRefs: any = {};
  @Input() defaultQboItemRefs: any[] = [];
  @Input() updateGenericItem: boolean = false;
  @Input() openFrom: string = '';
  @Input() isOpenFromPO: boolean = false;
  @Input() isInventoryEnabled: boolean = false;
  @Input() isMarkAsInventoryEnabled: boolean = false;
  @Input() isPartsTechItem: boolean = false;
  @Input() tireId: string = '';
  @Input() orderServiceId: string = '';
  @Input() isQboConnected: boolean = false;
  @Input() isInStorage: boolean = false;
  @Input() tireType: string = 'tire';
  @Input() tireStorageDisabledTooltip: string = '';
  @Input() isTireStorageList: boolean = false;
  @Input() itemResults: any[] = [[]];
  @Input() isSearching: boolean = false;
  @Input() isOpenFromRO: boolean = false;
  @Input() isFeeAssociationEnabled: boolean = false;
  @Input() isOpenFromST: boolean = false;
  @Input() isCommissionPlanEnabled: boolean = false;
  @Input() isEnhancedTSEnabled: boolean = false;
  @Input() isPricingMatricesManagement: boolean = false;
  @Input() isPricingManagementEnable: boolean = false;
  @Input() isNewItemCategoriesEnable: boolean = false;
  @Input() isAttributeBasedPricingEnable: boolean = false;
  @Input() averageCost: number = 0;
  @Input() latestPoCost: number = 0;
  @Input() isQTQAddOnEnable: boolean = false;
  @Input() isPassThroughTaxEnable: boolean = false;
  @Input() isTireConnectConnected: boolean = false;
  @Input() showLoaderTireconnect: boolean = false;
  @Input() previousTitle: string = '';
  @Input() previousTitleFR: string = '';
  @Input() isFromTireAdd: boolean = false;
  @Input('isModelFocusChange')
  set isModelFocusChange(focus: boolean) {
    this.setTireTitle();
  }
  @Input('isBrandFocusChange')
  set isBrandFocusChange(focus: boolean) {
    this.setTireTitle();
  }
  @Input('tire')
  set tire(tire: any) {
    this._tire = tire;
  }
  @Input('locations')
  set locations(locations: any) {
    if (locations?.length) {
      this.locationsResults = this.helperService.deepCopy(locations);
    }
  }

  @Output() appDeleteTireSize = new EventEmitter();
  @Output() appCheckForUniqueTitle = new EventEmitter();
  @Output() updatedField = new EventEmitter();

  @Output() selectFee = new EventEmitter();
  @Output() searchHazmatFee = new EventEmitter();
  @Output() addNewFee = new EventEmitter();
  @Output() removeFee = new EventEmitter();
  @Output() appAssociateFETFee = new EventEmitter();
  @Output() apponTooltipIconClicked = new EventEmitter();

  _tire: any = {};
  locationsResults: any[] = [];
  pricingMatrixResults: any[] = [];
  calculatedAmount: number = 0;
  focus: any = {};
  usd: string = currency.USD;
  isAddedManually: boolean = false;
  whichPricingMatrixUsed: any = '';
  initialData: any = {};
  selectedOption: boolean = true;
  activeStatus: any = true;
  tableConfig = {
    offset: 0,
    limit: config.pageSize,
    sortField: 'title',
    sortOrder: 1,
    search: '',
  };
  pricingMatrixList: any[] = [];
  listener: any = null;
  noMatrix = [
    {
      name: 'No pricing rules',
    },
  ];
  costOptions: any[] = [
    { label: 'Cost', value: 'cost' },
    { label: 'Avg. Cost', value: 'avg' },
    { label: 'Latest PO', value: 'latestPo' },
  ];
  tireConnectFetSouceValues: any = {
    tireconnect: '(Estimated)',
    '': '(Supplier provided)'
  };
  localizationSubscription: Subscription;
  companyLocalization: boolean = false;
  currentLang: string = 'en';

  constructor(
    private calculationService: CalculationService,
    private helperService: HelperService,
    private httpService: HTTPService,
    private dialogService: DialogService,
    private dataService: DataService
  ) { }

  ngOnInit() {
    this.listener = this.dataService.getData().subscribe((obj) => {
      const data = obj.data;
      if (data.key === 'category-selected') {
        this.checkCategoryOverAndApplyMatrix();
      }
    });
    this.getLocalizationFlags();
    this.isAttributeBasedPricingEnable = this.dataService.isAttributeBasedPricingEnable;
    this.pricingMatrixList = this.helperService.deepCopy(this.pricings);
    if (this.isAttributeBasedPricingEnable) {
      this.pricings = [...this.noMatrix || [], ...this.pricingRules || []];
    }
    this.pricingMatrixResults = this.helperService.deepCopy(this.pricings);
    this.initialData = this.helperService.deepCopy(this.size);

    if (this.size.title) {
      this.previousTitle = [this._tire.brand?.name, this._tire.model, this.size.size].filter((str) => str).join(' ');
    }

    //adding a fix for ALP-11959 - when open from inventory name should be combination of brand + model + tize size, as well
    if (['inventoryAdd'].includes(this.openFrom) && this.size.title && this.size?.title !== this.previousTitle) {
      this.size.title = [this._tire.brand?.name, this._tire.model, this.size.size].filter((str) => str).join(' ');
    }

    if (this.size.notes) {
      this.initialData.description = this.size.notes;
    }

    if (this.size.intenalNotes) {
      this.initialData.intenalNotes = this.size.intenalNotes;
    }

    if (this.size && this.size.pricingMatrix && this.size.pricingMatrix._id) {
      this.size.items = this.size.pricingMatrix?.items;
      this.applyMatrix(this.size.pricingMatrix);
      this.calculatePrice();
      this.checkPricingBackwardCompatibility();
    }

    this.defaultQboItemRefs = this.helperService.deepCopy(this.qboItemRefs);
  }

  getLocalizationFlags() {
    const { isMultiLocationEnabled } = this.helperService.getCompany();
    this.localizationSubscription = this.dataService.getCompanyLocalization().subscribe((value) => {
      if (value) {
        this.companyLocalization = value
        if (!isMultiLocationEnabled) {
          this.httpService.getCompanyPreferredLanguage().then((res: any) => {
            const lang = res.preferredLanguage
            if (lang) {
              this.currentLang = lang.toLowerCase();
            }
          });
        } else {
          this.httpService.getCompanyDetails(this.helperService.getCompany().companyId).then((company: any) => {
            const lang = company.shop.preferredLanguage;
            if (lang) this.currentLang = lang.toLowerCase();
          })
        }
      }
    })
  }

  isManuallyAdded() {
    return Number(this.size.price) !== Number(this.calculatedAmount);
  }

  checkPricingBackwardCompatibility() {
    const currentShopDetails = find(this.size?.shopDetails, { shopId: this.helperService.getCurrentShopId() });
    if (currentShopDetails && this.size?.price !== currentShopDetails?.price && !this.isOpenFromPO && !this.isOpenFromRO && !this.isOpenFromST) {
      this.size.price = currentShopDetails?.price;
      this.isAddedManually = Number(this.size.price) !== Number(this.calculatedAmount);
      if (this.isAddedManually) {
        this.size.pricingMatrix = {};
      }
    } else if (this.isOpenFromPO || this.isOpenFromRO || this.isOpenFromST) {

      this.size.pricingMatrix = this.size.pricingMatrixOnPO;
      if (this.size.price !== this.size.priceOnPO) {
        this.size.pricingMatrix = {};
      }
      this.size.price = this.size.priceOnPO;


    } else {
      if (this.size.initialPrice >= 0 && this.size.price !== this.size.initialPrice && !currentShopDetails) {
        this.size.price = this.size.initialPrice;
      }
    }
    this.size.totalPrice = this.size.price * this.size.count;
  }

  ngOnChanges(change: any) {
    const { pricings = [], tire } = change;

    if (pricings.previousValue && pricings.currentValue) {
      if (!pricings.previousValue.length && pricings.currentValue.length) {
        this.pricingMatrixList = this.helperService.deepCopy(this.pricings);
        if (this.isAttributeBasedPricingEnable) {
          this.pricings = [...this.noMatrix || [], ...this.pricingRules || []];
        }
        this.pricingMatrixResults = this.helperService.deepCopy(this.pricings);
        this.calculatePrice(false);
      }
    }
    // this.getLocations();
  }

  setTireTitle() {
    if (this.companyLocalization && this.currentLang === 'fr') {
      if (this.focus.titleFR || !this._tire) return;

      if (this._tire.brand?.titleFR && this._tire.model && (!this.size.titleFR || this.size.titleFR === this.previousTitleFR)) {
        const titleFR = [this._tire.brand?.titleFR, this._tire.model, this.size.size].filter((str) => str).join(' ');

        this.size.titleFR = titleFR;
        this.previousTitleFR = titleFR;

        this.appCheckForUniqueTitle.emit({
          title: titleFR,
          index: this.index,
        });
      }
    } else {
      if (this.focus.title || !this._tire) return;

      if (this._tire.brand?.name && this._tire.model && (!this.size.title || this.size.title === this.previousTitle)) {
        const title = [this._tire.brand?.name, this._tire.model, this.size.size].filter((str) => str).join(' ');

        this.size.title = title;
        this.previousTitle = title;

        this.appCheckForUniqueTitle.emit({
          title: title,
          index: this.index,
        });
      }
    }
  }

  handleFocus(type: string) {
    this.errors[type] = '';
    this.focus[type] = true;
  }

  onSearchLocation() { }

  search(query: string) {
    if (query) {
      const conf = {
        limit: 200,
        offset: 0,
        sortField: 'title',
        sortOrder: 1,
        search: query.trim(),
        activeStatus: this.activeStatus || '',
      };

      this.httpService.getLocations({ ...conf, structure: 'flat' }).then(
        (location: any) => {
          this.locationsResults = location.records.map(({ _id, title, warehouseId }) => ({
            locationId: _id,
            name: title,
            warehouseId: warehouseId,
          }));
        },
        (error) => {
          this.helperService.showToaster('error', error);
        }
      );
    } else {
      this.getLocations();
    }
  }

  getLocations(limit = 200, offset = this.tableConfig.offset, sortField: any = this.tableConfig.sortField, sortOrder = this.tableConfig.sortOrder, activeStatus = this.activeStatus, search = '') {
    const conf = {
      limit,
      offset,
      sortField,
      sortOrder,
      search,
      activeStatus,
    };

    this.httpService.getLocations({ ...conf, structure: 'flat' }).then(
      (location: any) => {
        this.locationsResults = location.records.map(({ _id, title, warehouseId }) => ({
          locationId: _id,
          name: title,
          warehouseId: warehouseId,
        }));
      },
      (err) => {
        this.helperService.showToaster('error', err);
      }
    );
  }

  getFETRatefromTireConnect() {
    this.apponTooltipIconClicked.emit();
  }

  setTireConnectFETRate() {
    this.size.fetValue = this.size?.tireconnectFetValue;
    if (this.size.fetValue) {
      this.appAssociateFETFee.emit();
    }

  }

  handleConfirmLocationUpdate(iLocation: any) {
    const { location } = this.size;

    if (!location || (location && !location.locationId)) {
      this.handleChange(iLocation, 'location');
    } else {
      const ref = this.dialogService.open(ConfirmDismissDialogComponent, {
        width: '30%',
        styleClass: 'small-heading-dialog',
        showHeader: false,
        data: {
          styleClassHeading: 'font-14',
          title: `Update location for ${this.size.title}`,
          message: `Changing the location for ${this.size.title} will also update its location on all the POs that have not been received so far. Do you want to continue?`,
          button: {
            success: { title: 'Confirm' },
            cancel: { title: 'Cancel' },
          },
        },
      });

      const onClose = ref.onClose.subscribe(({ isSuccess, data }) => {
        if (isSuccess) {
          this.handleChange(iLocation, 'location');
        }

        onClose.unsubscribe();
      });
    }
  }

  handleSelect(item, i) {
    this.selectFee.emit({
      event: item,
      sizeIndex: this.index,
      feeIndex: i,
    });
  }

  handleSearchSuggestion(event, i) {
    this.searchHazmatFee.emit({
      event: event,
      index: i,
      sizeIndex: this.index,
    });
  }

  handleFeeAddition() {
    this.addNewFee.emit();
  }

  handleRemove(i) {
    this.removeFee.emit({
      sizeIndex: this.index,
      feeIndex: i,
    });
  }

  getIconColor(): string {
    let iconColor: string = 'font-gray-65';
    if (this.size?.fetValue && this.size?.tireExternalId) {
      iconColor = 'font-primary';
    } else if (this.size?.tireExternalId) {
      iconColor = 'font-warning-800';
    } else {
      iconColor = 'font-gray-65';
    }

    return iconColor;
  }

  handleBlur(type: string) {
    if (type === 'cost' || type === 'price' || type === 'count') {
      // if(this.size.costType)
      if (type === 'cost' && this.size?.pricingMatrix?.name !== 'No pricing rules') {
        this.calculatePrice();
      }
      this.size.totalPrice = this.calculationService.roundOff(Number(this.size.price * this.size.count));
      this.size.totalCost = this.calculationService.roundOff(Number(this.size.cost * this.size.count));
    }

    if (type === 'fetValue') {
      this.appAssociateFETFee.emit();
    }

    this.focus[type] = false;
    this.isAddedManually = Number(this.size.price) !== Number(this.calculatedAmount);

    if (type === 'size') {
      if (this.companyLocalization) {
        if (this.size.titleFR === this.previousTitleFR && this.size.size && this._tire.brand?.name) {
          this.size.titleFR = `${this._tire.brand.name} ${this._tire.model} ${this.size.size}`;
          this.previousTitleFR = this.size.titleFR;
          this.appCheckForUniqueTitle.emit({
            titleFR: this.size.titleFR,
            index: this.index,
          });
        }
      }

      if (this.size.title === this.previousTitle && this.size.size && this._tire.brand?.name) {
        this.size.title = `${this._tire.brand.name} ${this._tire.model} ${this.size.size}`;
        this.previousTitle = this.size.title;
        this.appCheckForUniqueTitle.emit({
          title: this.size.title,
          index: this.index,
        });
      }
    }

    if (type === 'title') {
      this.appCheckForUniqueTitle.emit({
        title: this.size.title,
        index: this.index,
      });
    }
  }

  getFETPassthroughfee() {

  }

  handleChange(value: any, type: string) {
    if (type === 'fetValue') {
      this.size[type] = Number(value);
    } else {
      this.size[type] = value;
    }

    if (type === 'costType') {
      this.size[type] = value?.value;
      if (value?.value === 'avg') {
        this.size.cost = this.averageCost;
      } else if (value?.value === 'latestPo') {
        this.size.cost = this.latestPoCost;
      } else {
        this.size.cost = this.size?.initialDefaultCost;
      }
      this.applyMatrix(this.size.pricingMatrix);
      this.calculatePrice();

    }

    if (type === 'size') {
      this.setTireTitle();
    }

    this.updatedField.emit({
      field: type,
      isUpdated: this.initialData[type] !== value,
    });
    if (type === 'cost') {
      this.calculatePrice();
    }
    if (type === 'price') {
      // if price added manually
      this.size.pricingMatrix = this.noMatrix[0];
    }
    if (type === 'pricingMatrix') {
      this.applyMatrix(value);
      this.calculatePrice();
    } else if (type === 'title') {
      this.appCheckForUniqueTitle.emit({
        title: this.size.title,
        index: this.index,
      });
    }
  }
  applyMatrix(pricing) {
    if (pricing && pricing._id) {
      if (this.isAttributeBasedPricingEnable) {
        this.checkForOverrideCategory(pricing);
      } else {
        this.getUpdatedMatrixDetails(pricing, { id: pricing._id });
      }
    }
  }

  checkForOverrideCategory(pricing) {
    const categoryId = this._tire.category && this._tire.category._id;
    if (categoryId) {
      const overrideExist = pricing?.category?.find((c) => {
        return c._id === `${categoryId}`;
      })
      if (overrideExist) {
        this.getUpdatedMatrixDetails(pricing, overrideExist.matrix);
      } else {
        this.getUpdatedMatrixDetails(pricing, pricing.defaultMatrix);
      }
    } else {
      this.getUpdatedMatrixDetails(pricing, pricing.defaultMatrix);
    }
    if (!this.size?.pricingMatrix?.name) {
      this.size.pricingMatrix = this.noMatrix[0];
    }
  }
  getUpdatedMatrixDetails(rule, selectMatrix) {
    let matrixInfo = this.helperService.deepCopy(this.pricingMatrixList.find((m) => {
      if (selectMatrix) {
        return m._id === selectMatrix?.id;
      }
      return false;

    }));

    this.size.pricingMatrix = rule;
    this.size.pricingMatrix.items = matrixInfo?.items;
    this.size.pricingMatrix.matrixName = matrixInfo?.name;

  }
  handleSearch(type: string, query: string) {
    if (type === 'pricingMatrix') {
      this.pricingMatrixResults = this.pricings.filter(({ name }) => name && new RegExp(`${query}`, 'gi').test(name));
    }
  }

  calculatePrice(setPrice = true) {
    if (!this.size.cost || !(Object.keys(this.size?.pricingMatrix || {})?.length)) {
      return;
    }
    let markup = 0;
    let itemsLength = 0;

    if (this.size.pricingMatrix && this.size.pricingMatrix.items) itemsLength = this.size.pricingMatrix.items.length;
    else if (this.size.items && this.size.pricingMatrix?.name !== 'No pricing rules') itemsLength = this.size.items.length;

    if (itemsLength) {
      for (let i = 0; i < itemsLength; i++) {
        const item = this.size.pricingMatrix?.items ? this.size.pricingMatrix.items[i] : this.size.items[i];
        if (this.size.cost >= item.min && this.size.cost <= item.max) {
          markup = item.markup;
          break;
        }
      }
    }
    const price: any = this.calculationService.calculateMarkUpPrice(this.size.cost, markup);

    if (setPrice && this.size?.pricingMatrix?.name !== 'No pricing rules') {
      this.size.price = this.calculationService.roundOff(price);
    }
    this.calculatedAmount = this.calculationService.roundOff(price);
    this.isAddedManually = Number(this.size.price) !== Number(this.calculatedAmount);
    this.size.totalPrice = this.calculationService.roundOff(Number(this.size.price * this.size.count));
    this.size.totalCost = this.calculationService.roundOff(Number(this.size.cost * this.size.count));
    if (this.isAttributeBasedPricingEnable) {
      this.whichPricingMatrixUsed = `${this.size.pricingMatrix.name}:${this.size.pricingMatrix.matrixName}:${markup}`
    }

    this.updatedField.emit({
      field: 'price',
      isUpdated: this.initialData['price'] !== this.size.price,
      whichPricingMatrixUsed: this.whichPricingMatrixUsed,
    });

    this.errors.price = '';
  }

  handleDeleteSize() {
    this.appDeleteTireSize.emit(this.index);
  }

  onSearchItem(query: string) {
    this.httpService.getQBOItemRefs(query).then(
      (data: any) => {
        if (data.items) {
          this.qboItemRefs = data.items.filter(({ type }) => type === 'part');
        }
      },
      (err) => {
        this.helperService.showToaster('error', err);
      }
    );
  }

  handleClear(type: string = '') {
    if (type === 'pricingMatrix') {
      this.pricingMatrixResults = [...this.pricings];
    } else if (type === 'location') {
      this.getLocations();
    } else {
      this.qboItemRefs = this.helperService.deepCopy(this.defaultQboItemRefs);
    }
  }

  graphdata(itemId, type) {
    this.httpService.getSalesTrendHistory(itemId, type).then((res: any) => {
      this.dataService.stockItemdata.next(res.trend);
    });
  }

  checkCategoryOverAndApplyMatrix() {

    let matrixInfo = this.helperService.deepCopy(this.pricings);
    for (let i = 0; i < matrixInfo.length; i++) {
      if (matrixInfo[i]._id === (this?.size?.pricingMatrix?._id)) {
        this.applyMatrix(matrixInfo[i]);
        this.calculatePrice();
        break;
      }
    }
  }

  openQtyOnEstimateModal(size) {
    const name = size.title || size.titleFR || 'N/A';
    this.dialogService.open(QtyOnEstimateListModalComponent, {
      width: '1150px',
      styleClass: 'add-dialog qty-stock-list-modal',
      showHeader: false,
      data: {
        name,
        itemId: this.tireId,
      },
    });
  }

  ngOnDestroy() {
    if (this.listener) {
      this.listener.unsubscribe();
    }
    if (this.localizationSubscription) this.localizationSubscription.unsubscribe();
  }
}
